import axios from './base'
const url = `/log`

// ================= 日志中心（后端 LogController，/log/login） =================

// 登录日志列表（分页 + 筛选：username 模糊 / ip 模糊 / result 精确）
// 返回 data:{list,total,fail_total,page,page_size}
// 数据范围：超管看全部；普通账号只能看本公司账号的登录记录（失败行 company_id=0 按 admin_id 兜）
export function getLoginLogList(params = {}) {
  return axios.request({
    url: `${url}/login`,
    method: "get",
    params,
  })
}

// ================= 操作日志（后端 LogController，/log/operation） =================

// 操作日志列表（分页 + 筛选：admin_name 模糊 / module 精确 / operation 精确 / result 精确）
// 返回 data:{list,total,page,page_size}
// 数据范围：超管看全部；普通账号只看本公司操作记录
export function getOperationLogList(params = {}) {
  return axios.request({
    url: `${url}/operation`,
    method: "get",
    params,
  })
}

// 操作日志详情（追加 request_params / ip_location / user_agent）
// 返回 data:{ ...列表字段, request_params, ip_location, user_agent }
export function getOperationLogDetail(id) {
  return axios.request({
    url: `${url}/operation/${id}`,
    method: "get",
  })
}

// 操作日志导出（后端返回当前筛选下全部记录，最多 5000 条；前端据此生成 CSV）
// 返回 data:{list,total}
export function exportOperationLog(params = {}) {
  return axios.request({
    url: `${url}/operation/export`,
    method: "post",
    data: params,
  })
}

// ================= 数据库操作日志（后端 LogController，/log/sql；MongoDB 集合 mg_sql_log） =================

// 数据库操作日志列表（分页 + 筛选）
// 参数：start_date / end_date（Y-m-d 或 Y-m-d H:i:s，只给日期当天起止补齐）、
//       admin_id 精确、admin_name 模糊、sql 语句关键词模糊、connection 精确、page / page_size
// 返回 data:{list,total,page,page_size,start_date,end_date}（start_date/end_date 是实际生效范围回显）
// 未传时间范围时后端默认只查最近 24 小时（语句关键词是正则匹配、吃不到索引，必须有时间兜底）
export function getSqlLogList(params = {}) {
  return axios.request({
    url: `${url}/sql`,
    method: "get",
    params,
  })
}

// ================= 分享扫码日志（后端 LogController，/log/share；MongoDB 集合 mg_share_scan） =================

// 扫码日志列表（分页 + 筛选）
// 参数：start_date / end_date（Y-m-d 或 Y-m-d H:i:s，只给日期当天起止补齐）、
//       share_user_id 分享账号ID精确、scan_ip 扫码IP精确、page / page_size
// 返回 data:{list,total,page,page_size,start_date,end_date}（start_date/end_date 是实际生效范围回显）
// 未传时间范围时后端默认只查最近 7 天；list 每项带 share_user_name（分享人昵称，查不到为空）
export function getShareLogList(params = {}) {
  return axios.request({
    url: `${url}/share`,
    method: "get",
    params,
  })
}
